module.exports = __webpack_public_path__ + "static/img/settledPlatform_.e7c8e2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/settledPlatform_.png
// module id = Cte5
// module chunks = 18